import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import edapWrapper from '@homeaway/edap-wrapper';
import {Navigation} from '@homeaway/react-navigation';
import LinkpileItem from '../LinkpileItem/LinkpileItem';
import {
    EDAP_PAGE_MODULE_VIEW,
    EDAP_GENERIC_EVENT,
    EDAP_TABBED_LINKPILE_ACTION_LOCATION,
    EDAP_CONTENT_INTERACTION_SELECTED,
    EDAP_CONTENT_MODULE_PRESENTED,
    EDAP_TAB_CLICK,
    EDAP_INTERACTION_CLICK,
    EDAP_EVENT_POSITION_FIRED_TOP,
    EDAP_EVENT_POSITION_FIRED_BOTTOM
} from '../../constants';

import './Linkpile.less';

class Linkpile extends PureComponent {
    static propTypes = {
        /** List of object with "name" and "links" list. Each link includes
         a "title", "subtitle" and "href". */
        actionlocation: PropTypes.string,
        tabs: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                links: PropTypes.arrayOf(
                    PropTypes.shape({
                        title: PropTypes.string,
                        subtitle: PropTypes.string,
                        href: PropTypes.string
                    })
                )
            })
        ),
        isVisible: PropTypes.bool,
        /** Hide tabs header */
        hideTabs: PropTypes.bool
    };

    static defaultProps = {
        actionlocation: EDAP_TABBED_LINKPILE_ACTION_LOCATION,
        tabs: null,
        isVisible: false,
        hideTabs: false
    };

    constructor(props) {
        super(props);

        this.state = {
            activeIndex: 0,
        };
    }

    contentModulePresentedEventFired = {
        [EDAP_EVENT_POSITION_FIRED_TOP]: false,
        [EDAP_EVENT_POSITION_FIRED_BOTTOM]: false
    };

    fireContentModulePresentedEvent = (position) => (isVisible) => {
        const {actionlocation} = this.props;
        const edapWrapperInstance = edapWrapper();

        if (isVisible && !this.contentModulePresentedEventFired[position]) {
            if (position === EDAP_EVENT_POSITION_FIRED_BOTTOM) {
                edapWrapperInstance.push({
                    name: EDAP_PAGE_MODULE_VIEW,
                    data: {
                        actionlocation,
                    }
                });
            }
            edapWrapperInstance.push({
                name: EDAP_CONTENT_MODULE_PRESENTED,
                data: {
                    action_location: actionlocation,
                    position_fired: position
                }
            });
            this.contentModulePresentedEventFired[position] = true;
        }
    }

    handleTabClick = (event, activeIndex) => {
        const {tabs, actionlocation} = this.props;
        const eventrefinements = `label=[${tabs[activeIndex].name}]`;
        const edapWrapperInstance = edapWrapper();
        this.setState({activeIndex});

        edapWrapperInstance.push({
            name: EDAP_GENERIC_EVENT,
            data: {
                actionlocation,
                eventcategory: EDAP_INTERACTION_CLICK,
                eventaction: EDAP_TAB_CLICK,
                eventrefinements
            }
        });
        edapWrapperInstance.push({
            name: EDAP_CONTENT_INTERACTION_SELECTED,
            data: {
                action_location: actionlocation,
                event_category: EDAP_INTERACTION_CLICK,
                event_action: EDAP_TAB_CLICK,
                event_refinements: eventrefinements
            }
        });
    }

    getNavigationLinks() {
        const {tabs} = this.props;

        return tabs.map((tab) => ({
            label: tab.name,
            href: 'javascript:;' /* eslint no-script-url:0 */ /* Do nothing */,
            disabled: false
        }));
    }

    renderActiveLinkpileItems() {
        const {tabs} = this.props;
        const {activeIndex} = this.state;
        const activeTab = tabs[activeIndex];

        return activeTab.links.map((link, index) => {
            let itemProps = {
                title: link.title,
                subtitle: link.subtitle,
                href: link.href,
                key: index
            };
            return <LinkpileItem {...itemProps} />;
        });
    }

    renderInactiveLinkpileItems() {
        const {tabs, actionlocation} = this.props;
        const {activeIndex} = this.state;
        const inactiveTabs = tabs.filter((__, index) => index !== activeIndex);
        const inactiveLinks = inactiveTabs.reduce((links, tab) => {
            return links.concat(tab.links);
        }, []);

        return inactiveLinks.map((link, index) => {
            let itemProps = {
                actionlocation,
                title: link.title,
                subtitle: link.subtitle,
                href: link.href,
                key: index,
                style: {display: 'none'}
            };
            return <LinkpileItem {...itemProps} />;
        });
    }

    render() {
        const {activeIndex} = this.state;

        if (!this.props.tabs) {
            return null;
        }

        return (
            <React.Fragment>
                <VisibilitySensor delayedCall onChange={this.fireContentModulePresentedEvent(EDAP_EVENT_POSITION_FIRED_TOP)} >
                    <div style={{minHeight: '1px'}}/>
                </VisibilitySensor>
                <div className="linkpile clearfix">
                    {this.props.hideTabs ? null : (
                        <Navigation
                            links={this.getNavigationLinks()}
                            onLinkClick={this.handleTabClick}
                            activeIndex={activeIndex}
                            noMobileSelect
                        />
                    )}
                    <div className="linkpile-items">
                        {this.renderActiveLinkpileItems()}
                        {this.renderInactiveLinkpileItems()}
                    </div>
                </div>
                <VisibilitySensor delayedCall onChange={this.fireContentModulePresentedEvent(EDAP_EVENT_POSITION_FIRED_BOTTOM)} >
                    <div style={{minHeight: '1px'}}/>
                </VisibilitySensor>
            </React.Fragment>
        );
    }
}

export default Linkpile;
